<script>
  import { checkbox } from 'vue-strap';
  import 'vue-strap/dist/vue-strap-lang';
  import converterMoeda from '~js/converter-moeda';

  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        faixaValores: [],
        faixaValor: this.camposfaixaValor(),
      }
    },
    methods: {
      camposfaixaValor() {
        return {
          descricao: '',
          valor: '',
          utilizarArquivo: false,
          anexoObrigatorio: false,
          quantidadeMinimaArquivos: '',
          quantidadeMaximaArquivos: '',
          textoAnexo: '',
        }
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) {
              throw new Error("validacao");
            }
            else {
              this.solicitacao.solicitacaoCursoEventos[0].faixaValores.push(this.faixaValor);
              this.solicitacao.faixaValores = this.solicitacao.solicitacaoCursoEventos[0].faixaValores;
              this.faixaValor = this.camposfaixaValor();
              this.$validator.reset();
            }
          })
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      deletarFaixaValor(indice) {
        this.solicitacao.solicitacaoCursoEventos[0].faixaValores.splice(indice, 1);
        this.solicitacao.faixaValores = this.solicitacao.solicitacaoCursoEventos[0].faixaValores;
      },
      valorCategoria(faixa){
            if (faixa.valor == 0)
                return 'isento'

            if (!faixa.valor)
              return '---'
                   
            return faixa.valor;
        },
        retornaStringBooleano(valorBooleano) {
            if (typeof valorBooleano === "string") {
                if (valorBooleano === 'true' || valorBooleano === '1')
                    return 'Sim';

                return 'Não';
            }

            return valorBooleano ? 'Sim' : 'Não';
        }
    }
  }
</script>

<template>
  <div>
    <div class="ibox-footer">
      <div class="table-responsive">
        <table class="table table-bordered table-column-code table-column-action">
          <thead v-if="solicitacao.solicitacaoCursoEventos[0].faixaValores.length > 0">
            <tr>
              <th></th>
              <th>Categoria</th>
              <th style="width:90px;">Valor (R$)</th>
              <th v-if="configuracao.usarArquivosInscricao" style="width:90px;">Anexar arquivo</th>
              <th v-if="configuracao.usarArquivosInscricao" style="width:90px;">Arquivo obrigatório</th>
              <th v-if="configuracao.usarArquivosInscricao" style="width:90px;">Quantidade mínima arquivos</th>
              <th v-if="configuracao.usarArquivosInscricao" style="width:90px;">Quantidade máxima arquivos</th>
              <th v-if="configuracao.usarArquivosInscricao">Mensagem anexo</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="solicitacao.solicitacaoCursoEventos[0].faixaValores.length > 0">
            <tr v-for="(faixaValor, index) in solicitacao.solicitacaoCursoEventos[0].faixaValores">
              <td></td>
              <td>{{ faixaValor.descricao }}</td>
              <td style="width:90px;">{{ valorCategoria(faixaValor) }}</td>
              <td v-if="configuracao.usarArquivosInscricao" style="width:90px;">
                  {{retornaStringBooleano(faixaValor.utilizarArquivo)}}
              </td>
              <td v-if="configuracao.usarArquivosInscricao" style="width:90px;">
                  {{retornaStringBooleano(faixaValor.anexoObrigatorio)}}
              </td>
              <td v-if="configuracao.usarArquivosInscricao" style="width:90px;">{{ faixaValor.quantidadeMinimaArquivos || '---' }}</td>
              <td v-if="configuracao.usarArquivosInscricao" style="width:90px;">{{ faixaValor.quantidadeMaximaArquivos || '---' }}</td>
              <td v-if="configuracao.usarArquivosInscricao">{{ faixaValor.textoAnexo || '---' }}</td>
              <td>
                <div class="form-group no-margins">
                  <button type="button"
                          class="btn btn-sm btn-danger btn-delete-item"
                          title="Excluir item"
                          @click="deletarFaixaValor(index)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="solicitacao.solicitacaoCursoEventos[0].faixaValores.length === 0">
            <tr>
              <td class="text-center">Nenhuma categoria de inscrição encontrada.</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="row">
      <div :class="[configuracao.usarArquivosInscricao ? 'col-lg-4' : 'col-lg-10']">
        <div class="form-group required" :class="{'has-error': errors.has('descricao')}">
          <label class="control-label" for="descricao">Categoria</label>

          <input type="text"
                 class="form-control"
                 id="descricao"
                 v-model="faixaValor.descricao"
                 data-vv-name="descricao"
                 data-vv-as="categoria"
                 v-validate="'required'"
                 maxlength="300">
          <p class="text-danger" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</p>
        </div>
      </div>

      <div class="form-group required col-xs-2" :class="{'has-error': errors.has('valor')}">
        <label class="control-label" for="valor">Valor (R$)</label>

        <input type="text"
               class="form-control text-right"
               id="valor"
               v-mascara="'moeda'"
               v-model="faixaValor.valor"
               data-vv-name="valor"
               data-vv-as="valor"
               v-validate="'required'">

        <p class="text-danger" v-show="errors.has('valor')">{{ errors.first('valor') }}</p>
      </div>

      <div class="form-group col-xs-2" v-if="configuracao.usarArquivosInscricao">
          <div class="checkbox">
              <checkbox v-model="faixaValor.utilizarArquivo" value="1" type="primary">
                  Anexar arquivo
              </checkbox>
          </div>

          <div class="checkbox" style="padding-top: 6px">
              <checkbox v-model="faixaValor.anexoObrigatorio" value="1" type="primary" :disabled="!faixaValor.utilizarArquivo">
                  Arquivo obrigatório
              </checkbox>
          </div>
      </div>

      <div class="col-lg-2" v-if="configuracao.usarArquivosInscricao">
        <div class="form-group required" :class="{'has-error': errors.has('quantidadeMinimaArquivos')}">
          <label class="control-label" for="quantidadeMinimaArquivos">Quantidade mínima arquivos</label>

          <input id="quantidadeMinimaArquivos"
                 class="form-control"
                 type="text"
                 v-model="faixaValor.quantidadeMinimaArquivos"
                 :disabled="!faixaValor.anexoObrigatorio"
                 data-vv-name="quantidadeMinimaArquivos"
                 data-vv-as="quantidade mínima arquivos"
                 v-validate="faixaValor.anexoObrigatorio ? 'required' : ''"
                 v-numero>

          <p class="text-danger" v-show="errors.has('quantidadeMinimaArquivos')">{{ errors.first('quantidadeMinimaArquivos') }}</p>
        </div>
      </div>

      <div class="col-lg-2" v-if="configuracao.usarArquivosInscricao">
        <div class="form-group required" :class="{'has-error': errors.has('quantidadeMaximaArquivos')}">
          <label class="control-label" for="quantidadeMaximaArquivos">Quantidade máxima arquivos</label>

          <input id="quantidadeMaximaArquivos"
                 class="form-control"
                 type="text"
                 v-model="faixaValor.quantidadeMaximaArquivos"
                 :disabled="!faixaValor.anexoObrigatorio"
                 data-vv-name="quantidadeMaximaArquivos"
                 data-vv-as="quantidade máxima arquivos"
                 v-validate="faixaValor.anexoObrigatorio ? 'required' : ''"
                 v-numero>

          <p class="text-danger" v-show="errors.has('quantidadeMaximaArquivos')">{{ errors.first('quantidadeMaximaArquivos') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="faixaValor.utilizarArquivo">
      <div class="form-group col-xs-12">
        <label class="control-label" for="textoAnexo">Mensagem que irá aparecer nas inscrições sobre os arquivos para anexar</label>
        
        <textarea class="form-control"
                  id="textoAnexo"
                  v-model="faixaValor.textoAnexo">
        </textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-success" @click="validar">
            <i class="fa fa-plus"></i>
            Adicionar categoria
          </button>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormCategoriaValores.vue